import type { TranslationRow } from './interfaces';

/** The host's own namespace, which is what "application specific translations" means here. */
export const HOST_NAMESPACE = 'translation';

/** A bundle is a tree; the table is a list, keyed by the dotted path of each string. */
export const flatten = (node: unknown, prefix: string, rows: TranslationRow[]): void => {
  if (typeof node === 'string') {
    rows.push({ key: prefix, area: prefix.split('.')[0], value: node });
    return;
  }

  if (node && typeof node === 'object') {
    Object.entries(node).forEach(([key, child]) => flatten(child, prefix ? `${prefix}.${key}` : key, rows));
  }
};
